import detailExpense from "./detailExpense";

export default detailExpense;
